module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-44.de8c403a.png";